import './Login.css';
import { useState } from 'react';
import axios from 'axios'
import { Link } from 'react-router-dom';
import { useNavigate} from "react-router-dom";
import { useStateValue } from './State';
let count=0;
function Login() {
  const [{cart},dispatch]=useStateValue();
    const login=(stat)=>{
         dispatch({
             type:'login',
             status:stat,
             },
         );

         
    };
  const [email,setEmail]=useState('');
  const navigate = useNavigate();
  const [password,setPassword]=useState('');
  
  const handleSubmit=(e)=>{
    e.preventDefault();
    setEmail(e.target.email.value)
    setPassword(e.target.password.value)
    console.log(email,password);
    //window.alert("submitted");
    const request={
      email:e.target.email.value,
      password:e.target.password.value
    }
    axios.post('http://localhost:3000/login',request)
    .then(resp=>{
      
      if(resp.status===200)
      {
          login(true);
          navigate(`/`);
         
         

      }
    })
    .catch(err=>{
      console.log(err)
    })


    
    
  }
   const handleSubmit1=(e)=>{
    e.preventDefault();
    // setEmail(e.target.email.value)
    // setPassword(e.target.password.value)
    console.log(email,password);
    //window.alert("submitted");
    const request={
      email:e.target.email1.value,
      password:e.target.password1.value
    }
    axios.post('http://localhost:3000/register',request)
    .then(resp=>{
      alert(resp.data)
      
    })
    .catch(err=>{
      console.log(err)
    })


    
    
  }
  return (
    <div className="body1">
        <div className="back"><img src="https://wallpaperaccess.com/full/2932802.jpg" alt="" className="im_g" />
            </div>
        
      <div className="head1"><h1>Ecommerce APP</h1></div>
        <div className="head2"><h2>Login:</h2></div>
      <form onSubmit={(e)=>handleSubmit(e)}>
       <div className="form">
        <div className="roow">
        <p className="lab">Email:</p><input type="email" name="email" placeholder="abcd@gmail.com" className="input"/>
        </div>
        <div className="roow">
        <p className="lab">Password :</p><input type="text" name="password"/>
        </div>
        <button type="submit" className="bttn">Login</button>
          <Link to="/">
             <button className="bttn">Override</button>
             </Link>
       </div>
       
      </form>
      
    </div>
    
  );
  
}
export {count};

export default Login;
